import { FormControl, FormItem, FormMessage } from 'components/ui/form';
import { Switch } from 'components/ui/switch';
import * as React from 'react';
import { Label } from '../label';

type SwitchGsProps = {
  label: string;
  onCheckedChange?(checked: boolean): void;
  checked?: boolean;
};

export const SwitchGs = React.forwardRef<HTMLBaseElement, SwitchGsProps>(
  ({ label, onCheckedChange, checked }, ref) => {
    return (
      <FormItem>
        <FormControl>
          <div className="grid w-full items-center gap-1.5">
            {label && (
              <Label className="font-GilroySemibold text-sm text-slate-800">
                {label}
              </Label>
            )}
            <div className="flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm gap-2 justify-between">
              <span className="text-slate-800">{checked ? 'Sim' : 'Não'}</span>
              <Switch
                checked={checked}
                onCheckedChange={onCheckedChange}
                className="scale-90 !m-0"
              />
            </div>
            <FormMessage />
          </div>
        </FormControl>
      </FormItem>
    );
  }
);
